export default {
	wrapper: {
		position: 'relative',
		minHeight: '70vh',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
};

export const thresholdsRecipientListStyles = {
	wrapper: {
		position: 'relative',
		minHeight: '70vh',
		height: '100%',
	},
	loadingIndicatorWrapper: {
		position: 'absolute',
		left: '50%',
		top: '50%',
		transform: 'translate(-50%, -50%)',
	},
	noResultsFound: {
		flex: '1',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#aaa',
		fontSize: '14px',
		minHeight: '50vh',
	},
	uploadCsvInfo: {
		margin: '15px 0',
	},
	th: {
		cursor: 'auto',
	},
};

export const thresholdsValues = {
	th: {
		justifyContent: 'center',
		fontSize: '16px !important',
		maxWidth: '10%',
	},
	thName: {
		fontSize: '16px !important',
		maxWidth: '30%',
	},
	td: {
		textAlign: 'center',
		maxWidth: '10%',
	},
	tdName: {
		maxWidth: '30%',
	},
	wrapper: {
		position: 'relative',
		minHeight: '70vh',
		height: '100%',
	},
	loadingIndicatorWrapper: {
		position: 'absolute',
		left: '50%',
		top: '50%',
		transform: 'translate(-50%, -50%)',
	},
	noResultsFound: {
		flex: '1',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#aaa',
		fontSize: '14px',
		minHeight: '50vh',
	},
	uploadCsvInfo: {
		margin: '15px 0',
	},
	downloadTemplateButton: {
		marginLeft: '5px',
	}
};